import React from "react";

export function XPRing({ value, max, size = 120, stroke = 10, color = "#39FF14", label }) {
    const radius = (size - stroke) / 2;
    const c = 2 * Math.PI * radius;
    const pct = Math.min(1, (value || 0) / Math.max(1, max));
    const offset = c * (1 - pct);
    return (
        <div className="relative" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="#262626" strokeWidth={stroke} fill="none" />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={color}
                    strokeWidth={stroke}
                    fill="none"
                    strokeLinecap="round"
                    strokeDasharray={c}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 800ms ease", filter: `drop-shadow(0 0 6px ${color})` }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-display font-black text-3xl text-white leading-none">{value}</span>
                {label && (
                    <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">{label}</span>
                )}
            </div>
        </div>
    );
}

export function ProgressBar({ value, max, color = "#FF3B30", height = 8 }) {
    const pct = Math.min(100, ((value || 0) / Math.max(1, max)) * 100);
    return (
        <div className="w-full bg-charcoal-500 overflow-hidden" style={{ height }}>
            <div
                className="h-full transition-all duration-700"
                style={{ width: `${pct}%`, background: color, boxShadow: `0 0 12px ${color}` }}
            />
        </div>
    );
}
